<template>
    <error :code="405" :text="'Данное действие недоступно.'">

    </error>
</template>

<script>
    import Error from "./Error";

    export default {
        name: "Error405",
        components: {Error}
    }

</script>

<style scoped>

</style>